/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import NewUser from "../../users/newUser";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import { useEffect, useState } from "react";
import NewTerminal from "../terminals/newTerminal";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import toast from "react-hot-toast";
import useApi from "../../../components/Utils/api";


function MerchantTerminals(props) {
  const {merchant, openConfigurator, setOpenConfigurator, terminal, setTerminal, refreshMerchant} = props;
  const [terminals, setTerminals] = useState([]);
  const { terminalTablecolumns } = data();
  const [imeiDialogOpen, setImeiDialogOpen] = useState(false);
  const [imeiTerminal, setImeiTerminal] = useState(null);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [passwordResetTerminal, setPasswordResetTerminal] = useState(null);
  const api = useApi();

  function updateTerminalHandler(item) {
    setOpenConfigurator(true);
    setTerminal(item);
  }

  function handleConfirmDelete(item) {
    return;
  }

  function resetImeiHandler(item) {
    setImeiTerminal(item);
    setImeiDialogOpen(true);
  }

  function handleImeiResetSubmit() {
    api.post("/utils/resetimei", { tid: imeiTerminal.tid })
      .then(response => {
        if (response.data.statusCodeValue === 200) {
          setImeiDialogOpen(false);
          setImeiTerminal(null);
          refreshMerchant();
          toast.success(response.data.body);
        }
      })
      .catch(error => {
        if (error.response?.data?.body) {
          toast.error(error.response.data.body);
        }
      });
  }

  function resetAppPasswordHandler(item) {
    setPasswordResetTerminal(item);
    setPasswordDialogOpen(true);
  }

  function handlePasswordResetSubmit() {
    api.post("/utils/resetapppassword", { userId: passwordResetTerminal.tid })
      .then(response => {
        if (response.data.statusCodeValue === 200) {
          setPasswordDialogOpen(false);
          setPasswordResetTerminal(null);
          refreshMerchant();
          toast.success(response.data.body);
        }
      })
      .catch(error => {
        if (error.response?.data?.body) {
          toast.error(error.response.data.body);
        }
      });
  }

  useEffect(() => {
    const modifiedData = merchant.msisdn.map(item => {
      const action = (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <Icon fontSize="small" style={{cursor : 'pointer'}} onClick={(e) => { e.stopPropagation(); updateTerminalHandler(item); }}>create</Icon>
            <Icon title="Reset IMEI" fontSize="small" style={{cursor : 'pointer', marginLeft: '8px'}} onClick={(e) => { e.stopPropagation(); resetImeiHandler(item); }}>lock_reset</Icon>
            <Icon title="Reset App Password" fontSize="small" style={{cursor : 'pointer', marginLeft: '8px'}} onClick={(e) => { e.stopPropagation(); resetAppPasswordHandler(item); }}>password</Icon>
            {/*<Icon fontSize="small" style={{cursor : 'pointer'}} onClick={() => handleConfirmDelete(item)}>delete</Icon>*/}
          </MDBox>
      );
      return { ...item, action };
    });
    setTerminals(modifiedData);
  }, [merchant]);

  const onTerminalCloseHandler = () => {
    setTerminal({});
  }

  return (
      <Grid mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <MDBox sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, borderRadius: "8px", background: theme.palette.white.main, overflow: "hidden" })}>
              <DataTable
                table={{ columns : terminalTablecolumns, rows : terminals }}
                showTotalEntries={true}
                isSorted={true}
                noEndBorder
                entriesPerPage={{ defaultValue: 20, entries: [5, 10, 15, 20, 25] }}
                entriesPerPagePosition="bottom"
                canSearch={false}
              />
            </MDBox>
          </Grid>
        </Grid>
        <NewTerminal openConfigurator={openConfigurator} setOpenConfigurator={setOpenConfigurator} merchant={merchant} terminal={terminal} onTerminalCloseHandler={onTerminalCloseHandler} refreshMerchant={refreshMerchant} />
        <Dialog disableEscapeKeyDown open={imeiDialogOpen} onClose={() => setImeiDialogOpen(true)}>
          <DialogTitle>Reset Terminal IMEI</DialogTitle>
          <DialogContent>
            <Typography fontSize="medium">Do you really want to reset the IMEI for terminal id <Typography fontSize="medium" fontWeight="bold">{imeiTerminal?.tid}</Typography></Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setImeiDialogOpen(false); setImeiTerminal(null); }}>Cancel</Button>
            <Button onClick={handleImeiResetSubmit}>Ok</Button>
          </DialogActions>
        </Dialog>
        <Dialog disableEscapeKeyDown open={passwordDialogOpen} onClose={() => setPasswordDialogOpen(true)}>
          <DialogTitle>Reset App Password</DialogTitle>
          <DialogContent>
            <Typography fontSize="medium">Do you really want to reset the App password for terminal id <Typography fontSize="medium" fontWeight="bold">{passwordResetTerminal?.tid}</Typography></Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setPasswordDialogOpen(false); setPasswordResetTerminal(null); }}>Cancel</Button>
            <Button onClick={handlePasswordResetSubmit}>Ok</Button>
          </DialogActions>
        </Dialog>
      </Grid>
  );
}

MerchantTerminals.defaultProps = {
  merchant: false,
  openConfigurator: false,
  terminal: {},
}

MerchantTerminals.propTypes = {
  merchant: PropTypes.any,
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func.isRequired,
  terminal: PropTypes.any,
  setTerminal: PropTypes.func.isRequired,
  refreshMerchant: PropTypes.func.isRequired,
}

export default MerchantTerminals;
